import { QueryStringUtils, StringMap } from '@openid/appauth';

export class AngularQueryStringUtils implements QueryStringUtils {
  parse(input: Location, useHash?: boolean): StringMap {
    const url = input.href;
    const params: StringMap = {};
    
    const queryStart = url.indexOf('?');
    if (queryStart === -1) {
      return params;
    }
    
    const queryString = url.substring(queryStart + 1);
    const pairs = queryString.split('&');
    
    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      if (key) {
        params[decodeURIComponent(key)] = decodeURIComponent(value || '');
      }
    }
    
    return params;
  }

  parseQueryString(query: string): StringMap {
    const params: StringMap = {};
    const pairs = query.split('&');
    
    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      if (key) {
        params[decodeURIComponent(key)] = decodeURIComponent(value || '');
      }
    }
    
    return params;
  }

  stringify(input: StringMap): string {
    const pairs: string[] = [];
    for (const [key, value] of Object.entries(input)) {
      pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    return pairs.join('&');
  }
}
